import { render, staticRenderFns } from "./StudentFileUploadList.vue?vue&type=template&id=0ae104ba&scoped=true&"
import script from "./StudentFileUploadList.vue?vue&type=script&lang=ts&"
export * from "./StudentFileUploadList.vue?vue&type=script&lang=ts&"
import style0 from "./StudentFileUploadList.vue?vue&type=style&index=0&id=0ae104ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae104ba",
  null
  
)

export default component.exports